import { useState } from 'react';
import { AI_ENDPOINTS } from 'features/ai-generators/constants';
import { useShowAlert } from 'hooks';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useReferenceCheckSummarization = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const isSummaryWithAiEnabled = checkIfFeatureFlagEnabled(FeatureFlags.ReferenceCheckAISummary);

  const { showAlert } = useShowAlert();
  const [results, setResults] = useState(null);
  const [aiSummaryState, setAiSummaryState] = useState({
    isLoading: false,
    openDrawer: false
  });

  const closeSummarizedDrawer = () => {
    setAiSummaryState(prevState => ({
      ...prevState,
      openDrawer: false
    }));
    setResults(null);
  };

  const handleClickSummarizeWithAI = async referenceCheckId => {
    if (!referenceCheckId) return;

    try {
      setAiSummaryState(prevState => ({
        ...prevState,
        isLoading: true
      }));

      const response = await SECONDARY_API_CLIENT.get(
        AI_ENDPOINTS.summarizeReferenceCheck.replace(':id', referenceCheckId)
      );
      const normalizedResponse = Array.isArray(response?.data) ? response?.data : [];
      setResults(normalizedResponse);

      setAiSummaryState(prevState => ({
        ...prevState,
        isLoading: false,
        openDrawer: true
      }));
    } catch (error) {
      showAlert({
        title: strings.inventoryProfiles.sections.tabs.referenceCheck.aiSummary.failed,
        error
      });
      setAiSummaryState(prevState => ({
        ...prevState,
        isLoading: false
      }));
    }
  };

  return {
    aiSummaryState,
    closeSummarizedDrawer,
    handleClickSummarizeWithAI,
    isSummaryWithAiEnabled,
    results
  };
};
